/**
 * Get the Sutherland configuration from the global window object
 * This is a singleton accessor that provides type-safe access to configuration
 */
export const getSutherlandConfig = () => {
  if (!window.sutherland_variables) {
    throw new Error('Sutherland variables not initialized. Ensure the configuration is loaded before accessing it.');
  }
  return window.sutherland_variables;
};

/**
 * Get only the Genesys configuration
 */
export const getGenesysConfig = () => {
  return getSutherlandConfig().genesys;
};

/**
 * Get only the Survey configuration
 */
export const getSurveyConfig = () => {
  return getSutherlandConfig().survey;
};

/**
 * Get only the UI configuration
 */
export const getUiConfig = () => {
  return getSutherlandConfig().ui;
};

/**
 * Get only the Components configuration
 */
export const getComponentsConfig = () => {
  return getSutherlandConfig().components;
};

/**
 * Check if chat has ended
 */
export const isChatEnded = (): boolean => {
  return getSutherlandConfig().chat_ended;
};

/**
 * Check if chat should be restarted
 */
export const shouldRestartChat = (): boolean => {
  return getSutherlandConfig().restart_chat;
};

/**
 * Set chat ended status
 */
export const setChatEnded = (ended: boolean): void => {
  if (window.sutherland_variables) {
    window.sutherland_variables.chat_ended = ended;
  }
};

/**
 * Set restart chat status
 */
export const setRestartChat = (restart: boolean): void => {
  if (window.sutherland_variables) {
    window.sutherland_variables.restart_chat = restart;
  }
};

/**
 * Get i18n configuration
 */
export const getI18nConfig = () => {
  return getSutherlandConfig().i18n;
};

/**
 * Get language setting
 */
export const getLanguage = (): string => {
  return getSutherlandConfig().language;
};

/**
 * Get session expiry
 */
export const getSessionExpiry = (): number => {
  if (!window.sutherland_variables) {
    return 30 * 60 * 3; // Default to 3 hours if not initialized
  }
  return window.sutherland_variables.sessionExpiry || (30 * 60 * 3);
};
